<template>
  <Card :class="content_class">
    <div>
      <Card :bordered="false" dis-hover class="ivu-mb-16">
        <Form ref="formValidate" :model="formValidate" :label-width="100" label-position="right" class="tabform"
              @submit.native.prevent>
          <Row :gutter="24" type="flex">
            <Col span="24">
              <FormItem label="时间选择：">
                <RadioGroup v-model="timePeriod" @on-change="getList">
                  <Radio label="0"><span>不限</span></Radio>
                  <Radio label="1"><span>今日</span></Radio>
                  <Radio label="2"><span>昨日</span></Radio>
                  <Radio label="3"><span>本周</span></Radio>
                  <Radio label="4"><span>上周</span></Radio>
                  <Radio label="5"><span>本月</span></Radio>
                  <Radio label="6"><span>上月</span></Radio>
                  <Radio label="7"><span>自定义</span></Radio>
                  <DatePicker v-show="timePeriod == '7' " :value="timePeriodDate"
                              @on-change="timePeriodDateChange" type="daterange" placeholder="选择日期" class="date-picker"
                  ></DatePicker>
                </RadioGroup>
                <!-- 导入按钮 -->
                <Button style='margin: 0 0 0 10px' type="success" @click="handleImport">导入</Button>

                <!-- 文件上传组件（隐藏） -->
                <input
                    type="file"
                    ref="fileInput"
                    style="display: none"
                    accept=".csv,.xlsx,.xls"
                    @change="handleFileChange"
                >
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="账户：">
                <Select v-model="accountId" clearable placeholder="请选择账户" style="width: 100%" @on-change="getList">
                  <Option value="">全部</Option>
                  <Option :value="item.account_id" v-for="(item, index) in accountList" :key="index">
                    {{ item.account_name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="城市：">
                <Select v-model="cityName" clearable placeholder="请选择城市" style="width: 100%" @on-change="getList">
                  <Option value="">全部</Option>
                  <Option :value="item" v-for="(item, index) in cityList" :key="index">{{ item }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="账户名称：">
                <Input v-model="accountName" clearable placeholder="输入账户名称搜索" @on-enter="getList" @on-clear="getList">
                  <Button slot="append" icon="ios-search" @click="getList"></Button>
                </Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>

      <!-- 数据统计卡片 -->
      <Row :gutter="16" class="ivu-mb">
        <Col :xs="24" :sm="12" :md="6">
          <Card dis-hover>
            <p>总记录数</p>
            <h3 style="color: #2d8cf0;">{{ statistics.total_stats.total_records || 0 }}</h3>
          </Card>
        </Col>
        <Col :xs="24" :sm="12" :md="6">
          <Card dis-hover>
            <p>总消耗(元)</p>
            <h3 style="color: #19be6b;">{{ statistics.total_stats.total_consume_yuan || '0.00' }}</h3>
          </Card>
        </Col>
        <Col :xs="24" :sm="12" :md="6">
          <Card dis-hover>
            <p>总转化数</p>
            <h3 style="color: #ff9900;">{{ statistics.total_stats.total_conversions || 0 }}</h3>
          </Card>
        </Col>
        <Col :xs="24" :sm="12" :md="6">
          <Card dis-hover>
            <p>转化成本(元)</p>
            <h3 style="color: #ed4014;">{{ statistics.total_stats.conversion_cost || '0.00' }}</h3>
          </Card>
        </Col>
      </Row>

      <!-- 数据表格 -->
      <div style="width: 100% ;margin-top: 20px;">
        <Table :columns="columns" :data="datas" :loading="loading" ref="table">
        </Table>
      </div>

      <!-- 分页 -->
      <div class="pager">
        <Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
              :current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small"
              show-elevator/>
      </div>
    </div>
  </Card>
</template>

<script>
import { mapGetters } from "vuex";
import { getList, importData, getAccounts, getCities, getStatistics } from "@/api/baixinManage";

export default {
  name: "Import",
  props: ['content_class'],
  data() {
    return {
      loading: false,
      count: 0,
      page: 1,
      pageSize: 10,
      pageSizeOpts: [10, 50, 100, 500],
      timePeriod: '0',
      timePeriodDate: [],
      accountId: '',
      cityName: '',
      accountName: '',
      accountList: [],
      cityList: [],
      datas: [],
      statistics: {},
      columns: [
        {
          title: "日期",
          key: "start_date",
          align: 'center',
        },
        {
          title: "城市",
          key: "city_name",
          align: 'center',
        },
        {
          title: "账户ID",
          key: "account_id",
          align: 'center',
          width: 150
        },
        {
          title: "账户名称",
          key: "account_name",
          align: 'center',
          width: 200
        },
        {
          title: "消耗(元)",
          key: "cost",
          align: 'center',
        },
        {
          title: "转化数",
          key: "conversions_count",
          align: 'center',
        },
        {
          title: "创建时间",
          key: "created_at",
          align: 'center',
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  mounted() {
    this.loadAccountList();
    this.loadCityList();
    this.getList();
    this.getStatistics();
  },
  methods: {
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      return date.split(' ')[0]; // 只显示日期部分
    },

    // 时间选择变化
    timePeriodDateChange(e) {
      this.timePeriodDate = e;
      this.getList();
      this.getStatistics();
    },

    // 加载账户列表
    async loadAccountList() {
      try {
        let that = this;
        let data = { token: this.token };
        let res = await getAccounts(that, data);
        if (res.code == 1) {
          that.accountList = res.data.list || [];
        }
      } catch (error) {
        console.error('加载账户列表失败:', error);
      }
    },

    // 加载城市列表
    async loadCityList() {
      try {
        let that = this;
        let data = { token: this.token };
        let res = await getCities(that, data);
        if (res.code == 1) {
          that.cityList = res.data.list || [];
        }
      } catch (error) {
        console.error('加载城市列表失败:', error);
      }
    },

    // 获取数据列表
    async getList() {
      this.loading = true;
      let that = this;
      let data = {
        token: that.token,
        timePeriod: that.timePeriod,
        timePeriodDate: that.timePeriodDate,
        account_id: that.accountId,
        city_name: that.cityName,
        account_name: that.accountName,
        page: that.page,
        limit: that.pageSize
      };

      try {
        let res = await getList(that, data);
        if (res.code == 1) {
          that.datas = res.data.list || [];
          that.count = res.data.total || 0;
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$Message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    // 获取统计数据
    async getStatistics() {
      try {
        let that = this;
        let data = {
          token: that.token,
          timePeriod: that.timePeriod,
          timePeriodDate: that.timePeriodDate,
          account_id: that.accountId,
          city_name: that.cityName,
          account_name: that.accountName
        };

        let res = await getStatistics(that, data);
        if (res.code == 1) {
          that.statistics = res.data || {};
        }
      } catch (error) {
        console.error('获取统计数据失败:', error);
      }
    },

    // 分页变化
    changePage(e) {
      this.page = e;
      this.getList();
    },

    changeSize(e) {
      this.pageSize = e;
      this.page = 1;
      this.getList();
    },

    // 导入Excel文件（直接上传文件）
    handleImport() {
      this.$refs.fileInput.click();
    },

    // 文件选择变化
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 验证文件类型
      const fileType = file.name.split('.').pop().toLowerCase();
      if (!['csv', 'xlsx', 'xls'].includes(fileType)) {
        this.$Message.error('请上传CSV或Excel文件（.csv, .xlsx, .xls）');
        return;
      }

      // 验证文件大小（20MB）
      if (file.size > 20 * 1024 * 1024) {
        this.$Message.error('文件大小不能超过20MB');
        return;
      }

      // 确认导入
      this.$Modal.confirm({
        title: '确认导入',
        content: `是否导入文件 "${file.name}"？`,
        loading: true,
        onOk: () => {
          this.submitImportFile(file);
        }
      });

      // 清空文件选择
      event.target.value = '';
    },

    // 提交文件到后端
    async submitImportFile(file) {
      try {
        const that = this;
        const formData = new FormData();
        formData.append('excel_file', file);
        formData.append('token', this.token);

        // 显示上传进度
        const loadingInstance = this.$Message.loading({
          content: '正在上传文件...',
          duration: 0
        });

        const res = await importData(that, formData);

        // 关闭加载提示
        this.$Message.destroy();

        if (res.code == 1 || res.code == 200) {
          const data = res.data || {};
          this.$Message.success(data.message || `成功导入 ${data.success_count || 0} 条数据`);

          // 刷新数据
          this.getList();
          this.getStatistics();
          this.loadAccountList();
          this.loadCityList();

          // 关闭确认框
          this.$Modal.remove();
        } else {
          this.$Message.error(res.msg || '导入失败');
          this.$Modal.remove();
        }
      } catch (error) {
        this.$Message.error('导入失败：' + (error.message || '网络错误'));
        this.$Modal.remove();
        console.error('导入失败:', error);
      }
    }
  }
}
</script>

<style scoped lang="less">
.pager {
  margin-top: 20px;
  text-align: right;
}

.tabform {
  margin-bottom: 16px;
}

.ivu-mb {
  margin-bottom: 16px;
}
</style>